import { Loading } from '@piggybank/core';
import T from 'prop-types';
import React, { Suspense, lazy, useMemo } from 'react';
import { connect } from 'react-redux';
import { retry } from 'srcAlias/global/retry';
import { segmentConfigSelectors } from 'srcAlias/global/state/selectors';

export const Standalone = ({
  currentSegmentName,
  standaloneConfig,
  ...props
}) => {
  const { componentName, translationsScope } = standaloneConfig;

  const StandaloneComponent = useMemo(
    () =>
      lazy(() =>
        retry(() =>
          import(
            /* webpackInclude: /standalones[\/\\][a-zA-Z]+[\/\\]index\.js$/ */
            /* webpackChunkName: "standalone.[request]" */
            /* webpackMode: "lazy" */
            `./${componentName}`
          )
        )
      ),
    [componentName]
  );

  return (
    <Suspense fallback={<Loading show={true} />}>
      <StandaloneComponent
        currentSegmentName={currentSegmentName}
        standaloneMode={true}
        translationsScope={translationsScope}
        {...props}
      />
    </Suspense>
  );
};

Standalone.propTypes = {
  currentSegmentName: T.string.isRequired,
  standaloneConfig: T.object.isRequired,
};

export default connect((state, ...ownProps) => ({
  ...ownProps,
  currentSegmentName: segmentConfigSelectors.getCurrentSegmentName(state),
}))(Standalone);
